import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const BestOddsGuaranteed = ({ className, visible }) => {
    if (!visible) {
        return null;
    }
    return (
        <span className={classNames('bs-bog', className)}>
            Best Odds Guaranteed
        </span>
    );
};

BestOddsGuaranteed.defaultProps = {
    visible: true,
    className: '',
};

BestOddsGuaranteed.propTypes = {
    visible: PropTypes.bool,
    className: PropTypes.string,
};

export default BestOddsGuaranteed;



// WEBPACK FOOTER //
// /src/js/common/bestOddsGuaranteed/BestOddsGuaranteed.jsx